<mat-card>
    <mat-card-content>
        <form [formGroup]="contractForm" (ngSubmit)="onSubmit()">

            <!-- TOMADOR -->
            <div class="fons-gris" formGroupName="tomador">
                <h2>Tomador del seguro</h2>

                <!-- Nom -->
                <mat-form-field appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" required>
                </mat-form-field>
                <mat-error
                    *ngIf="contractForm.get('tomador.name')?.hasError('required') && contractForm.get('tomador.name')?.touched">
                    El nombre es obligatorio
                </mat-error>

                <!-- Cognoms -->
                <mat-form-field appearance="outline">
                    <mat-label>Primer Apellido</mat-label>
                    <input matInput formControlName="surname1" required>
                </mat-form-field>
                <mat-error
                    *ngIf="contractForm.get('tomador.surname1')?.hasError('required') && contractForm.get('tomador.surname1')?.touched">
                    El primer apellido es obligatorio
                </mat-error>

                <mat-form-field appearance="outline">
                    <mat-label>Segundo Apellido</mat-label>
                    <input matInput formControlName="surname2">

                </mat-form-field>
                <mat-error
                    *ngIf="contractForm.get('tomador.surname2')?.hasError('required') && contractForm.get('tomador.surname2')?.touched">
                    El segundo apellido es obligatorio
                </mat-error>
                <!-- Data naixement -->
                <mat-form-field appearance="outline">
                    <mat-label>Fecha de nacimiento</mat-label>
                    <input matInput [matDatepicker]="pickerT" formControlName="birthday">
                    <mat-datepicker-toggle matSuffix [for]="pickerT"></mat-datepicker-toggle>
                    <mat-datepicker #pickerT></mat-datepicker>
                </mat-form-field>
                <mat-error
                    *ngIf="contractForm.get('tomador.birthday')?.hasError('matDatepickerParse') && contractForm.get('tomador.birthday')?.touched">
                    Fecha inválida. Usa el formato Dia/Mes/Año.
                </mat-error>

                <mat-error *ngIf="contractForm.get('tomador.birthday')?.hasError('edatMinima18')">
                    Debe ser mayor de 18 años
                </mat-error>

                <mat-form-field appearance="outline">
                    <mat-label>Fecha de carnet</mat-label>
                    <input matInput [matDatepicker]="pickerLicense" formControlName="licenseDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerLicense"></mat-datepicker-toggle>
                    <mat-datepicker #pickerLicense></mat-datepicker>
                </mat-form-field>
                <mat-error
                    *ngIf="contractForm.get('tomador.licenseDate')?.hasError('matDatepickerParse') && contractForm.get('tomador.licenseDate')?.touched">
                    Fecha inválida. Usa el formato Dia/Mes/Año.
                </mat-error>
                <!-- DNI -->
                <mat-form-field appearance="outline">
                    <mat-label>DNI / NIE</mat-label>
                    <input matInput formControlName="dni">
                </mat-form-field>

                <mat-error *ngIf="contractForm.get('tomador.dni')?.hasError('invalidDniNie')">
                    DNI / NIE no válido
                </mat-error>

                <ng-container *ngIf="isNie(contractForm.get('tomador.dni')?.value)">
                    <p class="nie-warning"><strong>IMPORTANTE:</strong> Solo podemos asegurar conductores con carnet
                        europeo.</p>
                    <mat-checkbox class="cover-checkbox" formControlName="euLicense">
                        Mi carnet está expedido en la Unión Europea.
                    </mat-checkbox>
                    <mat-error
                        *ngIf="contractForm.get('tomador.euLicense')?.hasError('required') && contractForm.get('tomador.euLicense')?.touched">
                        <br />
                        Debes confirmar que tu carnet está expedido en la Unión Europea.
                    </mat-error>
                    <br /><br />
                </ng-container>

                <!-- CP -->
                <mat-form-field appearance="outline">
                    <mat-label>Código Postal</mat-label>
                    <input matInput formControlName="postalCode">
                </mat-form-field>

                <mat-error
                    *ngIf="contractForm.get('tomador.postalCode')?.hasError('required')  && contractForm.get('tomador.postalCode')?.touched">
                    Campo obligatorio
                </mat-error>
                <mat-error
                    *ngIf="contractForm.get('tomador.postalCode')?.hasError('postalInvalid') && contractForm.get('tomador.postalCode')?.touched">
                    Código postal inválido
                </mat-error>
                <mat-error
                    *ngIf="contractForm.get('tomador.postalCode')?.hasError('exclouCeutaMelilla') && contractForm.get('tomador.postalCode')?.touched">
                    Código postal inválido, sólo es posible asegurar en España peninsular, Baleares o Canarias.
                </mat-error>

                <!-- Domicili -->
                <mat-form-field appearance="outline">
                    <mat-label>Dirección</mat-label>
                    <input matInput formControlName="address" required>
                </mat-form-field>

                <!-- Domicili -->
                <mat-form-field appearance="outline">
                    <mat-label>Localidad</mat-label>
                    <input matInput formControlName="city" required>
                </mat-form-field>

                <!-- Email -->
                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input #emailInput matInput formControlName="email" required>
                </mat-form-field>

                <!-- Telèfon -->
                <mat-form-field appearance="outline">
                    <mat-label>Teléfono</mat-label>
                    <input matInput formControlName="phone" required>
                </mat-form-field>

            </div>

            <!-- CHECK SAME DRIVER -->
            <div class="main-wrapper">
                <mat-checkbox formControlName="sameDriverAsTomador">
                    El conductor es el mismo que el tomador
                </mat-checkbox>
            </div>

            <!-- CONDUCTOR -->
            <div class="fons-gris" formGroupName="conductor" *ngIf="!contractForm.get('sameDriverAsTomador')?.value">
                <h2>Conductor</h2>

                <!-- Reutilitzem el mateix patró que tomador -->
                <ng-container *ngTemplateOutlet="personFields; context:{role: 'conductor'}"></ng-container>
            </div>

            <!-- CHECK SAME OWNER -->
            <div class="main-wrapper">
                <mat-checkbox formControlName="sameOwnerAsTomador">
                    El propietario es el mismo que el tomador
                </mat-checkbox>
            </div>
            <!-- PROPIETARI -->
            <div class="fons-gris" formGroupName="propietari" *ngIf="!contractForm.get('sameOwnerAsTomador')?.value">
                <h2>Propietario del vehículo</h2>
                <ng-container *ngTemplateOutlet="personFields; context:{role: 'propietari'}"></ng-container>
            </div>

            <!-- VERIFICACIÓ MATRÍCULA -->
            <div class="fons-gris">
                <h2>Revisar matrícula</h2>
                <p class="plate-verify-text">Escribe de nuevo la matrícula del vehículo, si te pedimos esto es para comprobar que antes no te equivocaste al escribirla ya no será posible cambiarla una vez contratado el seguro.</p>
                <mat-form-field appearance="outline">
                    <mat-label>Matrícula</mat-label>
                    <input matInput formControlName="plateVerification" required>
                </mat-form-field>
                <div class="plate-mismatch-error" *ngIf="plateVerificationCtrl.dirty && plateVerificationCtrl.value?.length > 0 && !platesMatch">
                    <span>Las matrículas no coinciden.</span>
                    <a [routerLink]="['/price-form', state.vehicleType]">Volver para cambiar la matrícula</a>
                </div>

                <div class="review-row">
                    <h3 class="review-title">Fechas de contratación :</h3>
                    <span class="review-value">{{ state?.start_date | date:'dd/MM/yyyy' }} - {{ state?.end_date | date:'dd/MM/yyyy' }}</span>
                    <mat-icon class="review-edit" title="Cambiar fechas" (click)="goToDates()">edit</mat-icon>
                </div>
                <p class="plate-verify-text">Estos son los días que has elegido contratar. Revisa bien las fechas, ya que no será posible cambiarlas una vez contratado.</p>

                <div class="review-row">
                    <h3 class="review-title">Email :</h3>
                    <span class="review-value">{{ contractForm.get('tomador.email')?.value || '—' }}</span>
                    <mat-icon class="review-edit" title="Cambiar email" (click)="goToEmail()">edit</mat-icon>
                </div>
                <p class="plate-verify-text">Asegúrate que el mail está bien escrito para poder recibir la póliza.</p>
            </div>

            <!-- CONFIRMACIÓ -->
            <div class="main-wrapper">
                <mat-checkbox formControlName="allCorrect">
                    He revisado los datos y está todo correcto
                </mat-checkbox>
            </div>

            <!-- BOTÓ -->
            <div class="main-wrapper">
                <button mat-raised-button color="primary" type="submit" [disabled]="contractForm.invalid || !platesMatch"
                    style="width: 100% !important;">
                    Siguiente
                </button>
            </div>
            <!-- PLANTILLA REUSABLE PER PERSONA -->
            <ng-template #personFields let-role="role">
                <div class="fons-gris" formGroupName="{{role}}">
                    <h3>{{ role === 'conductor' ? 'Conductor' : 'Propietario del vehículo' }}</h3>
                    <mat-form-field appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="name" required>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Primer Apellido</mat-label>
                        <input matInput formControlName="surname1" required>

                    </mat-form-field>
                    <mat-error *ngIf="contractForm.get(role + '.surname1')?.hasError('required')">
                        El primer apellido es obligatorio
                    </mat-error>

                    <mat-form-field appearance="outline">
                        <mat-label>Segundo Apellido</mat-label>
                        <input matInput formControlName="surname2">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Fecha de nacimiento</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="birthday">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <mat-error *ngIf="contractForm.get(role + '.birthday')?.hasError('edatMinima18')">
                        Debe ser mayor de 18 años
                    </mat-error>
                    <mat-error
                        *ngIf="contractForm.get(role + '.birthday')?.hasError('matDatepickerParse') && contractForm.get(role + '.birthday')?.touched">
                        Fecha inválida. Usa el formato Dia/Mes/Año.
                    </mat-error>

                    <mat-form-field appearance="outline">
                        <mat-label>Fecha de carnet</mat-label>
                        <input matInput [matDatepicker]="pickerLicense" formControlName="licenseDate">
                        <mat-datepicker-toggle matSuffix [for]="pickerLicense"></mat-datepicker-toggle>
                        <mat-datepicker #pickerLicense></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                        *ngIf="contractForm.get(role + '.licenseDate')?.hasError('matDatepickerParse') && contractForm.get(role + '.licenseDate')?.touched">
                        Fecha inválida. Usa el formato Dia/Mes/Año.
                    </mat-error>

                    <mat-form-field appearance="outline">
                        <mat-label>DNI / NIE</mat-label>
                        <input matInput formControlName="dni">
                    </mat-form-field>

                    <mat-error *ngIf="contractForm.get(role + '.dni')?.hasError('invalidDniNie')">
                        DNI / NIE no válido
                    </mat-error>

                    <ng-container *ngIf="isNie(contractForm.get(role + '.dni')?.value)">
                        <p class="nie-warning"><strong>IMPORTANTE:</strong> Solo podemos asegurar conductores con carnet
                            europeo.</p>
                        <mat-checkbox class="cover-checkbox" formControlName="euLicense">
                            Mi carnet está expedido en la Unión Europea.
                        </mat-checkbox>
                        <mat-error
                            *ngIf="contractForm.get(role + '.euLicense')?.hasError('required') && contractForm.get(role + '.euLicense')?.touched">
                            Debes confirmar que tu carnet está expedido en la Unión Europea.
                        </mat-error>
                    </ng-container>
                </div>
            </ng-template>

        </form>
    </mat-card-content>
</mat-card>